import React from "react";
import 'react-lazy-load-image-component/src/effects/blur.css';
import {SocialIcon} from "../../Icon";

const Social = () => {
  const socialContent = [
    { id: 1, label: "Facebook", class : "facebook", icon: "facebook-f", link: "https://www.facebook.com/talents.handicap" },
    { id: 2, label: "X", class : "twitter", icon: "x-twitter", link: "https://x.com/TalentsHandicap" },
    { id: 3, label: "Instagram", class : "instagram", icon: "instagram", link: "https://www.instagram.com/talents.handicap" },
    { id: 4, label: "Linkdin", class : "linkedin", icon: "linkedin-in", link: "https://www.linkedin.com/company/talents-handicap/mycompany/" },
  ];
  return (
    <>
      {socialContent.map((item) => (
          <SocialIcon icon={item.icon}
                      url={item.link}
                      className={item.class}
                      label={item.label}
                      target="_blank" />
      ))}
    </>
  );
};

export default Social;
